import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconXCircleFillComponent } from "./med-icon-x-circle-fill.component";

@NgModule({
  declarations: [
    MedIconXCircleFillComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconXCircleFillComponent,
  ],
})
export class MedIconXCircleFillModule { }
